import { render } from "./PopWidget.vue?vue&type=template&id=aedd36c2&scoped=true"
import script from "./PopWidget.vue?vue&type=script&lang=js"
export * from "./PopWidget.vue?vue&type=script&lang=js"

import "./PopWidget.vue?vue&type=style&index=0&id=aedd36c2&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aedd36c2"]])

export default __exports__